'use client';

import { MessageCircle } from 'lucide-react';
import { SUPPORT_LINE_URL } from '@/lib/support';

// Contact-support button backed by the official LINE account (URL lives in
// lib/support.ts). Shown in 個人設置 and the membership-details modal.
export function SupportButton() {
  if (!SUPPORT_LINE_URL) {
    return (
      <p className="rounded-xl bg-zinc-100 px-4 py-3 text-center text-sm text-zinc-500 dark:bg-zinc-800">
        客服 LINE 即將提供
      </p>
    );
  }
  return (
    <a
      href={SUPPORT_LINE_URL}
      target="_blank"
      rel="noreferrer"
      className="flex w-full items-center justify-center gap-2 rounded-xl bg-[#06C755] py-2.5 font-medium text-white active:scale-[0.99]"
    >
      <MessageCircle size={18} /> 加 LINE 聯繫客服
    </a>
  );
}
